import { QueryClient } from "@tanstack/react-query";
import { fetchItineraryData } from "@/hooks/product-detail-page/itinerary/use-itinerary";
import { StaticContent } from "@/types/dto/pdp/pdp-contentful";

const prefetchItinerary = (
  queryClient: QueryClient,
  packageId: string,
  packageDateId: string,
  neoId: string,
  currencyId: string,
  marketId: string,
  staticContent: StaticContent
) => {
  queryClient.prefetchQuery({
    queryKey: ["PDP_ITINERARY", neoId, packageId, packageDateId, currencyId, marketId],
    queryFn: fetchItineraryData(packageId, packageDateId, neoId, staticContent?.tourContent?.landingPageId, currencyId, marketId),
    staleTime: Infinity
  });
};

export default prefetchItinerary;